/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon24Regular = forwardRef('ArrowAUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.744 10.556A.875.875 0 1 1 3.506 9.32L9.79 3.035a3.125 3.125 0 0 1 4.42 0l6.284 6.284a.875.875 0 1 1-1.238 1.237l-6.284-6.284a1.403 1.403 0 0 0-.097-.088V21a.875.875 0 1 1-1.75 0V4.184a1.403 1.403 0 0 0-.097.088l-6.284 6.284Z" })));
});
